import React from 'react';

interface URLMigrationProps {
    children: JSX.Element;
    oldDomain: string;
    newUrl: string;
    currentDomain: string;
    Loader: React.FC;
}

const CA_BLOCKED = 'credavenueBlocked';
const URLMigration = ({ children, oldDomain, newUrl, currentDomain, Loader }: URLMigrationProps): JSX.Element => {
    const [isBlockChecking, setIsBlockedChecking] = React.useState<boolean>(false);
    const blockCheck = localStorage.getItem(CA_BLOCKED) || false;
    React.useEffect(() => {
        if (oldDomain === currentDomain) {
            setIsBlockedChecking(true);
            fetch(newUrl, { method: 'GET' })
                .then((d) => {
                    if (d.text()) {
                        setIsBlockedChecking(false);
                        localStorage.removeItem(CA_BLOCKED);
                        window.location.href = window.location.href.replace(window.location.origin, newUrl);
                    }
                })
                .catch(() => {
                    if (!blockCheck) localStorage.setItem(CA_BLOCKED, 'true');
                    setIsBlockedChecking(false);
                });
        }
    }, []);

    if (isBlockChecking) return <Loader />;
    return <>{children}</>;
};

export default URLMigration;
